export default __webpack_public_path__ + "static/media/Thunderkick.c9f08206.png";